const TriangleIcon = () => {
  return (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9L0.803848 0L11.1962 0L6 9Z" fill="#D9D9D9" />
    </svg>
  );
};

export default TriangleIcon;
